import { render, staticRenderFns } from "./MetrcDetails.template.vue?vue&type=template&id=f664f1f2&scoped=true&"
var script = {}
import style0 from "./MetrcDetails.template.vue?vue&type=style&index=0&id=f664f1f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f664f1f2",
  null
  
)

export default component.exports